function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M359.944 359.623C359.944 359.623 215.349 565.872 359.944 791.239L363.442 836.011L424.403 803.536L409.039 606.019L387.829 352.774",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M387.835 352.757L526.639 318.661L525.336 460.351V836.059H414.862L426.543 815.135L387.835 352.757Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M437.7 73.3891C438.494 73.3891 439.138 72.7454 439.138 71.9514C439.138 71.1574 438.494 70.5137 437.7 70.5137C436.905 70.5137 436.261 71.1574 436.261 71.9514C436.261 72.7454 436.905 73.3891 437.7 73.3891Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M418.622 73.3891C419.416 73.3891 420.06 72.7454 420.06 71.9514C420.06 71.1574 419.416 70.5137 418.622 70.5137C417.827 70.5137 417.184 71.1574 417.184 71.9514C417.184 72.7454 417.827 73.3891 418.622 73.3891Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M428.155 88.6676V66.4721H417.038",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M446.513 66.4721H435.386",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M463.695 85.5503C465.693 85.5503 467.608 84.7571 469.021 83.3453C470.433 81.9335 471.227 80.0187 471.227 78.0221",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M468.456 72.397C468.456 72.397 486.921 38.5141 458.466 32.4037C458.466 32.4037 446.866 17.9303 430.39 24.95C413.914 31.9698 405.989 27.0387 405.755 33.6924C405.521 40.3461 404.714 51.4156 412.557 57.0639L413.324 109.947L467.21 123.187V90.854",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M428.157 88.6875L433.025 89.8817",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M432.714 97.0422C432.714 97.0422 439.36 100.307 442.987 93.7775",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M526.639 201.05V318.669L359.939 359.623V228.628C359.947 206.063 367.522 184.153 381.454 166.397C395.385 148.642 414.868 136.067 436.79 130.682V130.682C447.47 128.056 458.608 127.894 469.361 130.206C480.113 132.518 490.199 137.245 498.855 144.028C507.511 150.811 514.509 159.473 519.322 169.359C524.135 179.245 526.635 190.095 526.634 201.089L526.639 201.05Z",
  fill: "#131313"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M426.543 815.135L387.835 352.766",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M516.241 163.584C524.844 179.731 528.761 197.961 527.552 216.215C526.357 235.022 519.399 257.073 500.06 279.289C449.272 337.669 266.933 252.886 258.295 211.291C257.64 208.164 257.142 205.006 256.804 201.83C254.484 179.331 263.985 173.941 268.368 175.777C270.176 176.533 267.941 178.963 268.155 181.314C269.315 194.214 280.652 188.454 280.652 188.454C280.652 188.454 282.178 172.212 287.251 176.797C292.323 181.382 293.869 189.94 293.869 189.94L416.315 222.433C416.315 222.433 440.815 163.829 503.145 147.635C503.18 147.663 513.5 158.173 516.241 163.584Z",
  fill: "#C6E547",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M500.069 291.703C474.122 321.518 413.861 301.582 359.946 281.533C413.851 301.575 474.117 309.122 500.069 279.299C519.399 257.083 521.994 244.076 526.483 225.657C526.483 247.251 523.84 264.386 500.069 291.703Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M409.226 141.93C409.226 141.93 363.999 170.1 345.43 203.614",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M287.428 244.064C287.428 244.064 222.589 250.009 190.082 255.42C157.576 260.832 194.144 267.651 194.144 267.651C194.144 267.651 211.072 292.023 240.198 282.543C240.198 282.543 299.566 310.977 359.954 295.405",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M279.051 189.044L283.173 167.677L277.399 167.094L274.94 166.85L269.177 166.267L268.993 185.19",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M292.229 158.014C293.061 149.724 287.012 142.329 278.719 141.497C270.425 140.665 263.027 146.711 262.195 155.001C261.363 163.292 267.411 170.687 275.705 171.519C283.999 172.35 291.397 166.304 292.229 158.014Z",
  fill: "#131313"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M457.854 72.402L453.433 54.3623C453.433 54.3623 421.199 54.8593 415.845 46.0804",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M115.585 231.378L249.412 345.042V836.059H115.585",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M361.851 1.24228V63.8782H338.682V77.9574L324.814 63.8782H268.489V1.24228H361.851Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M361.85 1.23233V63.8782H338.682",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M299.635 29.6939H293.892V35.4349H299.635V29.6939Z",
  fill: "#131313"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M318.04 29.6939H312.297V35.4349H318.04V29.6939Z",
  fill: "#131313"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M336.447 29.6939H330.704V35.4349H336.447V29.6939Z",
  fill: "#131313"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2505 104.832V139.798H73.1855V147.656L80.9207 139.798H112.378V104.832H60.2505Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2505 104.824V139.807H73.1855",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M98.1888 120.715H94.9824V123.92H98.1888V120.715Z",
  fill: "#131313"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M87.9167 120.715H84.7103V123.92H87.9167V120.715Z",
  fill: "#131313"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M77.6364 120.715H74.43V123.92H77.6364V120.715Z",
  fill: "#131313"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M1.2428 158.726V183.737H10.4941V189.369L16.0337 183.737H38.5398V158.726H1.2428Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M1.2428 158.717V183.74H10.4941",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3854 170.082H26.092V172.374H28.3854V170.082Z",
  fill: "#131313"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M21.038 170.082H18.7446V172.374H21.038V170.082Z",
  fill: "#131313"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6823 170.082H11.3889V172.374H13.6823V170.082Z",
  fill: "#131313"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M1.2428 67.2009V92.2238H10.4941V97.8555L16.0337 92.2238H38.5398V67.2009H1.2428Z",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M1.2428 67.2009V92.2238H10.4941",
  stroke: "black",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3854 78.5653H26.092V80.8577H28.3854V78.5653Z",
  fill: "#131313"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M21.038 78.5653H18.7446V80.8577H21.038V78.5653Z",
  fill: "#131313"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6823 78.5653H11.3889V80.8577H13.6823V78.5653Z",
  fill: "#131313"
});

var SvgGridMan = function SvgGridMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 838,
    viewBox: "0 0 529 838",
    fill: "none",
    className: "hidden md:block ml-auto mt-12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGridMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GridMan.5ac5d6b2.svg";
export { ForwardRef as ReactComponent };